import { gql } from 'graphql-request';

import { MemberDataExport } from '../types';
import { axiosQuery } from '../utils/axiosQuery';

export interface GetMemberDataExportsResponse {
  memberDataExports: {
    canInitiateNewExport: boolean;
    exports: MemberDataExport[];
  };
}

const GET_MEMBER_DATA_EXPORTS_QUERY = gql`
  query GetMemberDataExports {
    memberDataExports {
      canInitiateNewExport
      exports {
        ... on ApiScheduledMemberDataExport {
          id
          status
          scheduledAt
          createdAt
        }
        ... on ApiProcessingMemberDataExport {
          id
          status
          createdAt
        }
        ... on ApiFailedMemberDataExport {
          id
          status
          createdAt
        }
        ... on ApiCancelledMemberDataExport {
          id
          status
          createdAt
        }
        ... on ApiCompletedMemberDataExport {
          id
          status
          completedAt
          downloadUrlExpiresAt
          createdAt
        }
      }
    }
  }
`;

export const getMemberDataExports = () =>
  axiosQuery<GetMemberDataExportsResponse>('GetMemberDataExports', GET_MEMBER_DATA_EXPORTS_QUERY);
